import { LocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/locations/location.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface EmspBoLocationListActionsHeaderProps
  extends HeaderContext<LocationModel, unknown> {}

export const EmspBoLocationListActionsHeader =
  () // props: EmspBoLocationListActionsHeaderProps,
  : ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    // Nothing to do

    // RENDER ////////////////////////////////////////////////////////////////////

    return '';
  };
